<template>
    <svg width="30px" height="30px" viewBox="0 0 32 32" id="OBJECT" xmlns="http://www.w3.org/2000/svg" fill="#016B00">
        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
        
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
        
        <g id="SVGRepo_iconCarrier">
        
        <defs>
       
        
        </defs>
        
        <title/>
        
        <rect height="26" rx="1" ry="1" width="18" x="5" y="5"/>
        
        <path class="cls-1" d="M26.71,7.29l-6-6A1,1,0,0,0,20,1H10A1,1,0,0,0,9,2V26a1,1,0,0,0,1,1H26a1,1,0,0,0,1-1V8A1,1,0,0,0,26.71,7.29Z"/>
        
        <path d="M20.71,1.29A1,1,0,0,0,20,1V7a1,1,0,0,0,1,1h6a1,1,0,0,0-.29-.71Z"/>
        
        <path d="M19,13.5H14a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z"/>
        
        <path d="M22,17.5H14a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"/>
        
        <path d="M22,21.5H14a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"/>
        </g>
        </svg>
</template>


 
<style>.cls-1{fill:#CCAF12;}</style>